




import Vue from 'vue'

import { DateTimeService } from '../services/DateTimeService'

export default Vue.extend({
  props: {
    datetime: {
      required: true
    },
    autoUpdate: {
      type: [Number, Boolean]
    },
  },
  data() {
    return {
      timeAgo: this.getTimeAgo(this.datetime) as any,
      updater: null as any
    }
  },
  mounted(): void {
    this.startUpdater()
  },
  beforeDestroy(): void {
    this.stopUpdater()
  },
  methods: {
    getTimeAgo(datetime: any): string {

      return DateTimeService.humanizeTimestamp(datetime, true)
    },
    convert(): void {
      this.timeAgo = this.getTimeAgo(this.datetime)
    },
    startUpdater(): void {
      if (this.autoUpdate) {
        const updateInterval = this.autoUpdate === true ? 60 : this.autoUpdate

        this.updater = setInterval(() => {
          this.convert()
        }, updateInterval * 1000)
      }
    },
    stopUpdater(): void {
      if (this.updater) {
        clearInterval(this.updater)
        this.updater = null
      }
    },
  },
  watch: {
    autoUpdate(newValue): void {
      this.stopUpdater()
      if (newValue) this.startUpdater()
    },
    datetime(): void {
      this.convert()
    },
  }
})
